// Constans
import { ROLES } from '@/constants'
// Components
import VuetifyTabs from '@/components/ui/VuetifyTabs'
import PlaceManagedList from '@/components/elements/app/PlaceManagedList'
import PlaceReferredList from '@/components/elements/app/PlaceReferredList'
import PlaceBrandedList from '@/components/elements/app/PlaceBrandedList'
// Vuex
import { mapGetters } from 'vuex'
// Utils
import { cloneDeep } from 'lodash'

export default {
  name: 'PlaceByTabs',
  components: {
    VuetifyTabs
  },
  data() {
    return {
      items: [
        {
          label: 'Gestionados',
          component: PlaceManagedList
        }
      ]
    }
  },
  computed: {
    ...mapGetters('authentication', ['userData']),
    /**
     * Pestañas que se mostrarán en el componente
     *
     * @return {array}
     */
    customItems() {
      // items de las pestañas
      const items = cloneDeep(this.items)
      // Usuario es "partner"
      const isPartner = ROLES.partner_partner.value === this.userData.role

      if (isPartner) {
        items.push({
          label: 'Referidos',
          component: PlaceReferredList
        })
      } else {
        items.push({
          label: 'Patrocinados',
          component: PlaceBrandedList
        })
      }

      return items
    }
  }
}
